import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { SectionHeading, SettingsLayout } from 'src/components/app-ui'
import WidgetView from 'src/pages/collection/components/collection-page-view/components/collection-share/components/share-popover/components/widget-view'
import usePathSettings from '../hooks/usePathSettings'
import { tabPath } from '../tabs'
import LinksSection from './links-section'

const WidgetSection = () => (
  <>
    <SectionHeading
      title="Widget"
      description="Deliver seamless experiences with widgets that work as sidebars, modals, direct links, or embedded blocks."
    />
    <WidgetView />
  </>
)

/** `value` is the `share/:subPage` URL segment. */
const SECTIONS = [
  { value: 'url', label: 'Links', icon: 'tabler:link' },
  {
    value: 'widget',
    label: 'Widget',
    icon: 'tabler:apps',
    trailingIcon: 'tabler:link',
    trailingHint: 'Uses the direct link',
  },
]

const ShareTab = () => {
  const history = useHistory()
  const { id, subPage } = useParams()
  const { collection } = usePathSettings()
  const active = subPage === 'widget' ? 'widget' : 'url'

  return (
    <SettingsLayout
      items={SECTIONS}
      value={active}
      onChange={value => history.push(tabPath(id, 'share', value))}
      navWidth={220}
      minHeight={480}
    >
      {active === 'widget' ? (
        <WidgetSection />
      ) : (
        <LinksSection collection={collection} />
      )}
    </SettingsLayout>
  )
}

export default ShareTab
